"use strict";

const moment = require("moment-timezone");

class DateUtil {
  static dateStringToAWSDateTime(dateString) {
    if (dateString == null) {
      return null;
    }

    return dateString + "T00:00:00.000Z";
  }

  /**
   * Ignoruje TimeZone a vlozi priznak ZULU/UTC na postgresu je timestamp without TZ, takze se to bude ignorovat
   * Dulezite je zde neprovodet zadne casove posuny.
   * @param {*} date
   */
  static dateToAWSDateTime(date) {
    if (date == null) {
      return null;
    }

    return moment(date).utcOffset(0, true).format();
  }

  static awsDateTimeToJSDate(awsDateTime) {
    return moment(awsDateTime).toDate();
  }

  // TODO: predelat na primou transformaci pres doDate + orez casove zony
  static zuluTimeStringToLocalTime(timeString) {
    // console.log("timeString");
    // console.log(timeString);
    let m = moment.utc(timeString);
    let dateString = m.format("YYYY-MM-DDTHH:mm:ss.sss") + moment().format("Z");
    // console.log("dateString:");
    // console.log(dateString);
    let d = new Date("2025-01-01"); // vytvoreni neutralniho datumu
    d.setFullYear(m.year());
    d.setDate(m.date());
    d.setMonth(m.month());
    
    d.setHours(m.hours());
    d.setMinutes(m.minutes());
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d;
    // return Date.parse(
    //   dateString  
    // );
  }

  static fitDateToBussinessHours(
    bhFromHour,
    bhFromMinute,
    bhToHour,
    bhToMinute,
    timeToFit
  ) {
    let today = moment();

    let todayStart = moment().startOf("day");
    todayStart.hour(bhFromHour);
    todayStart.minute(bhFromMinute);
    todayStart.second(0);

    let todayEnd = moment().startOf("day");
    todayEnd.hour(bhToHour);
    todayEnd.minute(bhToMinute);
    todayEnd.second(0);

    let tomorrowStart = moment().startOf("day").add(1, "day");
    tomorrowStart.hour(bhFromHour);
    tomorrowStart.minute(bhFromMinute);
    tomorrowStart.second(0);

    if (timeToFit.isSame(today, "day")) {
      // pred otvirackou -- posun na dnesni otviracku
      if (timeToFit.isBefore(todayStart)) {
        return todayStart;
      }
      // po otviracce -- posun na zitrejsi otviracku
      else if (timeToFit.isAfter(todayEnd)) {
        return tomorrowStart;
      }
      // jinak je tim padem v ramci dnesni otviracky
      else {
        return timeToFit;
      }
    } else {
      return timeToFit;
    }
  }

  static isWeekend(date) {
    const day = moment(date).day(); // Get day of the week (0 - Sunday, 6 - Saturday)
    return day === 0 || day === 6;  // Return true for weekend
}
}

module.exports = DateUtil;
